module.exports = __webpack_public_path__ + "static/img/cha2-bg.af07952.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cha2-bg.png
// module id = yrCa
// module chunks = 1